export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            iconClasses: ['font-icon', 'font-icon-dashboard'],
            iconClass: 'material-icons',
            iconName: 'dashboard',
            color: 'navy',
        },
        {
            name: 'Content',
            children: [
                { name: 'Layouts', route: 'layouts', shortcut: 'layout/_' },
                { name: 'Pages', route: 'pages', type: 'page', shortcut: 'page/_' },
                { name: 'Panel library', route: 'panels', type: 'panel', shortcut: 'panel/_' },
                // { name: 'Quick Links', route: 'quick_links', type: 'quick_link', shortcut: 'quick_link/_' },
            ],
            iconClass: 'material-icons',
            iconName: 'content_copy',
            color: 'navy',
        },
        {
            name: 'Assets',
            route: 'assets',
            type: 'asset',
            iconClass: 'material-icons',
            iconName: 'photo_album',
            color: 'navy',
        },
        {

            name: 'News',
            children: [
                { name: 'Posts', route: 'news_posts', type: 'news_post' },
                { name: 'Categories', route: 'news_categories', type: 'news_category' },
            ],
            iconClass: 'material-icons',
            iconName: 'perm_media',
            color: 'navy',
        },
        // {
        //     name: 'Testimonials',
        //     route: 'testimonials',
        //     iconClass: 'material-icons',
        //     iconName: 'sentiment_satisfied_alt',
        //     color: 'navy',
        // },
        // {
        //     name: 'Service',
        //     route: 'service',
        //     iconClass: 'material-icons',
        //     iconName: 'devices_other',
        //     color: 'navy',
        // },
       
        {
            name: 'Products',
            children: [
                { name: 'Products', route: 'products', type: 'product' },
            ],
            iconClass: 'material-icons',
            iconName: 'store',
            color: 'navy',
        },
        {
            name: 'LGS Framing',
            route: 'lgs_framing',
            type: 'lgs_framing',
            iconClass: 'material-icons',
            iconName: 'grid_on',
            color: 'navy',
        },
        {
            name: 'Customers',
            ...{ name: 'Customers', route: 'customers', type: 'customer' },
            iconClass: 'material-icons',
            iconName: 'store',
            color: 'navy',
        },
        {
            name: 'Calculations',
            children: [
                { name: 'Projects', route: 'customer_projects', type: 'customer_project' },
                { name: 'Calculations', route: 'span_calculations', type: 'span_calculation' },
            ],
            iconClass: 'material-icons',
            iconName: 'calculate',
            color: 'navy',
        },
        {
            name: 'Staff',
            type: 'staff_member',
            route: 'staff_members',
            iconClass: 'material-icons',
            iconName: 'perm_contact_calendar',
            color: 'navy',
        },
        {
            name: 'Enquiries',
            children: [
                { name: 'Enquiries', route: 'enquiries', type: 'enquiry' },
                { name: 'Subscribers', route: 'subscribers', type: 'subscriber' },
                { name: 'Downloads', route: 'downloads', type: 'download' },
            ],
            iconClass: 'material-icons',
            iconName: 'forum',
            color: 'navy',
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users', shortcut: 'user/_', type: 'user' },
                { name: 'Roles', route: 'roles', shortcut: 'role/_', type: 'role' },
            ],
            iconClass: 'material-icons',
            iconName: 'account_box',
            color: 'navy',
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            iconClass: 'material-icons',
            iconName: 'settings',
            color: 'navy',
        }
    ],
    defaultItem: 'Content',
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/menu.js